import { render, staticRenderFns } from "./PartCkuPrvsMTable.vue?vue&type=template&id=2694ef6d&"
import script from "./PartCkuPrvsMTable.vue?vue&type=script&lang=js&"
export * from "./PartCkuPrvsMTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports